import React from "react";
import { MHeaderProps } from "../../MHeader";

export interface SubLayoutContextProps {
    headerProps: MHeaderProps;
    setHeaderProps: (props: Partial<MHeaderProps>) => void;
}

export const SubLayoutContext = React.createContext<SubLayoutContextProps>({
    headerProps: { title: "", goBack: () => null },
    setHeaderProps: () => null
});
